import { isEmpty } from 'utilities/helperFunctions';

const React = require('react');
const storage = require('../utilities/storage');
const CurrencyHelper = require('../utilities/currencyHelper');
const StringHelper = require('utilities/stringHelper');
import { isDevtoolsAllowed } from 'utilities/devUtils';

const { getReferenceLanguageByCountry } = require('utilities/multiLanguageHelper');

const okCloudDomain = 'ok-cloud.net';
const hostname = window.location.hostname;
const hostArray =
    hostname === okCloudDomain || hostname.slice(-okCloudDomain.length - 1) === '.' + okCloudDomain
        ? okCloudDomain
        : hostname.split('.');
let domain = '';

if (Array.isArray(hostArray)) {
    domain = hostArray.length > 1 ? hostArray.slice(1).join('.') : [hostArray[hostArray.length - 1]].join('.');
} else {
    domain = hostArray;
}
export const NOT_FOUND_TRANSLATION = '######';

function setOnbCookie(lang) {
    const conf =
        domain === 'localhost'
            ? {}
            : {
                  domain,
                  secure: true,
              };
    storage.cookies.set('language', lang, conf);
}

const setLanguageApplication = () => {
    const language = storage.cookies.get('language');
    const languageByCountry = getReferenceLanguageByCountry();
    const lastPageWasEnglishPublic = /\/en/.test(document.referrer);
    const languageByUrl = StringHelper.getParameterByName('language');

    if (languageByUrl) {
        setOnbCookie(languageByUrl);

        return languageByUrl;
    }

    if (lastPageWasEnglishPublic) {
        setOnbCookie(languageByCountry.secundary);

        return languageByCountry.secundary;
    }

    if (language) {
        if (languageByCountry.primary !== language && languageByCountry.secundary !== language) {
            setOnbCookie(languageByCountry.primary);
        } else {
            return language;
        }
    } else {
        setOnbCookie(languageByCountry.primary);
    }

    return storage.cookies.get('language');
};

export function jsonMerge(file1, file2) {
    return Object.assign({}, file1, file2);
}

const language = setLanguageApplication();
export const getLanguage = () => language;
const file1 = require(`ok-translations-onboarding/webapp/${language}.json`);
const file2 = require(`ok-translations-web-shared/webapp/${language}.json`);
let config = jsonMerge(file1, file2);

export const setConfig = translations => {
    config = Object.assign(config, translations);
};

function formatCurrency(number, lang = null) {
    lang = !lang ? getLanguage() : lang;
    switch (lang) {
        case 'en':
            return CurrencyHelper.format(number, 2, ',', '.');
        case 'es':
        default:
            return CurrencyHelper.format(number, 2, '.', ',');
    }
}

function isStringCodeValid(stringCode, warnings = false) {
    if (!stringCode || isEmpty(stringCode)) {
        warnings && window.console.log('You need to specify a string code');

        return false;
    }

    const prefixIndex = stringCode.indexOf('-');
    const prefix = stringCode.slice(0, prefixIndex);
    const suffix = stringCode.slice(prefixIndex + 1);

    if (!prefix || !suffix) {
        warnings && window.console.log(`The string code ${stringCode} should have a prefix and a code`);

        return false;
    }

    if (!config[prefix]) {
        warnings && window.console.log(`prefix  ${prefix} is invalid`);

        return false;
    }

    if (config[prefix][suffix] === undefined) {
        warnings &&
            window.console.log(
                `The string code ${suffix} is not included in the defined translations for prefix ${prefix}`
            );

        return false;
    }

    return true;
}

function replaceInjectedStrings(result, injectedStrings) {
    if (injectedStrings && injectedStrings instanceof Array) {
        injectedStrings.forEach(value => {
            result = result.replace(/%s/, value);
        });
    }

    return result;
}

export function formatText(stringCode, injectedStrings, withOriginCountry = false) {
    let translation = null;

    if (isDevtoolsAllowed() && typeof window.allowShowStrings !== 'undefined' && window.allowShowStrings) {
        translation = stringCode;

        return translation;
    }

    if (isStringCodeValid(stringCode, true)) {
        const prefixIndex = stringCode.indexOf('-');
        const prefix = stringCode.slice(0, prefixIndex);
        let suffix = stringCode.slice(prefixIndex + 1);

        if (withOriginCountry) {
            suffix = `${suffix}_${__ORIGIN_COUNTRY__}`;
        }

        translation = config[prefix][suffix];
        translation = replaceInjectedStrings(translation, injectedStrings);

        if (translation === undefined) {
            translation = config[prefix][suffix.split('_')[0]];
            translation = replaceInjectedStrings(translation, injectedStrings);
        }
    }

    return translation != null ? translation : NOT_FOUND_TRANSLATION;
}

export class FormattedText extends React.Component {
    render() {
        const { value, injectedStrings, format, className } = this.props;
        let response;
        let message = formatText(value, injectedStrings);
        switch (format) {
            case 'uppercase':
                message = message.toUpperCase();
                break;
            case 'camelCase':
                message = StringHelper.toCamelCase(message);
                break;
            case 'firstUppercase':
                message = message.charAt(0).toUpperCase() + message.substr(1).toLowerCase();
                break;
            case 'lowercase':
                message = message.toLowerCase();
                break;
            default:
                break;
        }
        // We check if the stored message has HTML tags.
        if (/<[a-z][\s\S]*>/i.test(message)) {
            // Because the strings are previously stored, we can use dangerouslySetInnerHTML without risks
            response = <span dangerouslySetInnerHTML={{ __html: message }}></span>; //eslint-disable-line react/no-danger
        } else {
            response = <span className={className}>{message}</span>;
        }

        return response;
    }
}

export function HtmlText(injectedStrings) {
    let response;
    if (/<[a-z][\s\S]*>/i.test(injectedStrings)) {
        response = <span dangerouslySetInnerHTML={{ __html: injectedStrings }}></span>; //eslint-disable-line react/no-danger
    } else {
        response = <span>{injectedStrings}</span>;
    }

    return response;
}

const publicMethods = {
    formatText,
    formatCurrency,
    getLanguage,
    FormattedText,
    HtmlText,
    setOnbCookie,
    jsonMerge,
    setConfig,
};

export const i18n = publicMethods;

module.exports.test = function (_config) {
    config = _config;

    return publicMethods;
};
